import {apiFetch} from 'src/api/fetch'
import {driverFetch} from 'src/driver-view/driver-fetch'

import {
    type DeployEquipmentInput,
    deployEquipmentRequestRawSchema,
    type DeployStockEquipmentInput,
    deployStockEquipmentRequestRawSchema,
    type DriverEquipmentDeployment,
    driverEquipmentDeploymentRawSchema,
    type DriverStockEquipmentDeployment,
    driverStockEquipmentDeploymentRawSchema,
    type EquipmentLocationEventList,
    equipmentLocationEventListRawSchema,
    mapDriverEquipmentDeployment,
    mapDriverStockEquipmentDeployment,
    mapEquipmentLocationEventList,
} from './schemas'

export async function listEquipmentLocationEvents(
    assetId: string,
    options?: {limit?: number},
): Promise<EquipmentLocationEventList> {
    const limit = options?.limit ?? 20
    const raw = await apiFetch<unknown>(
        `/rental-assets/${assetId}/equipment-location-events?limit=${limit}`,
    )
    return mapEquipmentLocationEventList(equipmentLocationEventListRawSchema.parse(raw))
}

export async function deployEquipment(
    jobId: string,
    accessToken: string,
    input: DeployEquipmentInput,
): Promise<DriverEquipmentDeployment> {
    const body = deployEquipmentRequestRawSchema.parse(input)
    const raw = await driverFetch<unknown>(
        `/driver/jobs/${jobId}/equipment-deployments`,
        accessToken,
        {
            method: 'POST',
            body: JSON.stringify(body),
        },
    )
    return mapDriverEquipmentDeployment(driverEquipmentDeploymentRawSchema.parse(raw))
}

export async function deployStockEquipment(
    jobId: string,
    accessToken: string,
    input: DeployStockEquipmentInput,
): Promise<DriverStockEquipmentDeployment> {
    const body = deployStockEquipmentRequestRawSchema.parse(input)
    const raw = await driverFetch<unknown>(
        `/driver/jobs/${jobId}/stock-equipment-deployments`,
        accessToken,
        {
            method: 'POST',
            body: JSON.stringify(body),
        },
    )
    return mapDriverStockEquipmentDeployment(driverStockEquipmentDeploymentRawSchema.parse(raw))
}
